import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    NullableBooleanInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin';

import { EditToolbar } from '../../common/EditToolbar';
import FileUpload from '../../common/inputs/FileUpload';

const DownloadEdit = () => {
    return (
        <Edit title={<Title />} redirect={'/downloads'}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="title" fullWidth />
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    required={true}
                    label="select thumbnail"
                    source="thumbnail"
                    accept="image/*"
                    multiple={false}
                />
                <FileUpload
                    type="PDF_NOTES"
                    required={true}
                    source="url"
                    label="select Pdf"
                    accept="application/pdf"
                    multiple={false}
                />
                <TextInput source="display_order" type={'number'} fullWidth />
                <NullableBooleanInput source={'is_demo'} defaultValue={true} />
                <ReferenceInput source="category_id" reference="download_categories" fullWidth>
                    <SelectInput optionText={'name'} />
                </ReferenceInput>
            </SimpleForm>
        </Edit>
    );
};

const Title = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    return record ? (
        <span>
            {translate('resources.download_categories.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default DownloadEdit;
